import React from 'react';

import { Grid } from '@material-ui/core';

import { Chip } from 'components/v2';
import FiltersListWrapper from 'components/FixedFilters/FiltersListWrapper';
import { useFiltersContext } from 'components/FixedFilters/context/FixedFiltersContext';
import { BILLING_ITEM_KEY } from '../../constants';

interface FilterListProps {
  data: any;
}

const FilterList: React.FC<FilterListProps> = ({ data }) => {
  const { filters, updater } = useFiltersContext();
  const billingItemFilter = filters[BILLING_ITEM_KEY];

  const isSelected = (id: string) =>
    (billingItemFilter.includes('all') && !billingItemFilter.includes(id)) ||
    (billingItemFilter.includes('all') && billingItemFilter.length === 1) ||
    (!billingItemFilter.includes('all') && billingItemFilter.includes(id));

  const handleSelectItem = (item: any) => {
    updater(BILLING_ITEM_KEY)(item.id);
  };

  return (
    <FiltersListWrapper>
      <Grid container spacing={8}>
        {data.map((item: any) => (
          <Grid item key={item.id}>
            <Chip
              color="supportPowder"
              label={item.name}
              selected={isSelected(item.id)}
              onClick={() => handleSelectItem(item)}
            />
          </Grid>
        ))}
      </Grid>
    </FiltersListWrapper>
  );
};

export default FilterList;
